var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"head_top"}},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"title"},[_vm._v("供应商人员画像")])])])}]

export { render, staticRenderFns }